import React from 'react';

// Bulleted / numbered text, one item per line. The bullet or number is drawn
// as its own text (not the browser's list marker, which adds a built-in gap),
// so `spacing` is the exact space in px between the marker and the text:
// 0 puts them right next to each other. Wrapped lines align with the text.
export default function ListLines({ lines, type, spacing = 0, textStyle = {} }) {
    const isNumbered = type === 'decimal';
    // Numbers are right-aligned in a fixed-width box so "9." and "10." line up.
    const markerWidth = isNumbered ? `${String(lines.length).length + 1}ch` : undefined;
    const { textAlign, ...inheritedStyle } = textStyle;

    return (
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {lines.map((line, idx) => (
                <li
                    key={idx}
                    style={{
                        ...inheritedStyle,
                        display: 'flex',
                        alignItems: 'baseline',
                        marginBottom: idx < lines.length - 1 ? '4px' : '0'
                    }}
                >
                    <span
                        aria-hidden="true"
                        style={{
                            flex: '0 0 auto',
                            minWidth: markerWidth,
                            textAlign: isNumbered ? 'right' : undefined
                        }}
                    >
                        {isNumbered ? `${idx + 1}.` : '•'}
                    </span>
                    <span style={{ flex: '1 1 auto', minWidth: 0, marginLeft: spacing + 'px', textAlign }}>
                        {line || ' '}
                    </span>
                </li>
            ))}
        </ul>
    );
}
